
import bannerImage from '../images/cover.png'; // ya da oluşturduğumuz özel görseli burada kullanabilirsin
import TeamSection from '../components/Team';

const Ueber = () => {
  return (
    <div className="bg-black text-white font-sans">
      {/* HERO BANNER */}
      <section className="relative h-[80vh] w-full overflow-hidden">
        <img
          src={bannerImage}
          alt="Banner"
          className="absolute inset-0 w-full h-full object-cover brightness-[.5] scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 backdrop-blur-sm" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div className="space-y-5 max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-pink-500 drop-shadow-2xl">
              Über <span className="text-white">Net Moove</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 italic drop-shadow-sm">
              Innovativ. Digital. Menschlich.
              <br />Wir sind nicht nur eine Agentur – wir sind Mitgestalter deiner Zukunft.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT */}
      <div className="max-w-6xl mx-auto px-6 py-24 space-y-24">
        {/* INTRO */}
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-gray-300 text-lg leading-relaxed">
            Net Moove ist eine kreative Digitalagentur mit Sitz in Berlin. Unsere DNA? Technologie. Design. Strategie. Seit unserer Gründung treiben wir die digitale Transformation für Startups, Mittelstand und Corporates gleichermaßen voran.
            <br /><br />
            Mit einem interdisziplinären Team aus Designern, Entwicklern, Strategen und KI-Experten setzen wir Maßstäbe – mutig, datengestützt und zukunftsorientiert.
          </p>
        </div>

        {/* MISSION & VISION */}
        <div className="grid md:grid-cols-2 gap-12">
          {[
            {
              title: 'Unsere Mission',
              text: 'Wir begleiten Unternehmen auf dem Weg zur digitalen Exzellenz – mit Leidenschaft, Präzision und einem kompromisslosen Fokus auf Nutzerbedürfnisse.'
            },
            {
              title: 'Unsere Vision',
              text: 'Eine digitale Welt, in der Technologie den Menschen dient, nicht umgekehrt. Wir glauben an Mensch-zentrierte Innovation, Ehrlichkeit und Wirkung.'
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white/5 border border-gray-700 hover:border-fuchsia-500 transition-all duration-300 rounded-xl p-6 shadow-xl"
            >
              <h3 className="text-2xl font-bold text-fuchsia-300 mb-4">{item.title}</h3>
              <p className="text-gray-400 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        {/* TEAM */}
        <div className="text-center space-y-6">
          <h3 className="text-3xl font-semibold text-fuchsia-400">Das Team hinter Net Moove</h3>
         <TeamSection/>
        </div>

        {/* SERVICES */}
        <div>
          <h2 className="text-3xl font-bold text-center text-fuchsia-400 mb-12">Unsere digitalen Kompetenzen</h2>
          <div className="grid md:grid-cols-2 gap-10 text-gray-300 text-base leading-relaxed">
            {[
              { icon: '💻', title: 'Webentwicklung', desc: 'Von der Landingpage bis zum komplexen Webportal: Wir entwickeln performante, responsive Websites mit modernsten Frameworks wie React, Next.js und Tailwind CSS.' },
              { icon: '📱', title: 'Mobile Apps', desc: 'Native & Cross-Plattform Apps (React Native, Flutter), die intuitiv sind, schnell funktionieren und in den App Stores überzeugen.' },
              { icon: '🎨', title: 'UX/UI Design', desc: 'Wir designen Benutzererlebnisse, die begeistern. Mit Fokus auf Nutzerführung, Ästhetik und Conversion.' },
              { icon: '🤖', title: 'AI & Automatisierung', desc: 'Wir integrieren KI-Lösungen wie Chatbots, GPT-basierte Assistenten oder Machine-Learning-Pipelines direkt in deine digitalen Produkte.' },
              { icon: '🚀', title: 'Digitale Strategie & Beratung', desc: 'Wir analysieren Geschäftsprozesse, Zielgruppen und digitale Potenziale – und entwickeln mit dir gemeinsam Strategien, die wirklich wirken.' },
              { icon: '🔒', title: 'Sicherheit & Skalierbarkeit', desc: 'DSGVO-konform, cloud-ready und zukunftssicher: Unsere Lösungen sind auf Stabilität, Performance und Datenschutz ausgelegt.' }
            ].map((item, i) => (
              <div key={i} className="hover:text-white transition">
                <h3 className="text-lg font-semibold mb-2">
                  <span className="text-xl">{item.icon}</span> {item.title}
                </h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* VALUES */}
        <div className="grid md:grid-cols-3 gap-6 text-center">
          {[
            { icon: '🔍', title: 'Transparenz', desc: 'Wir sprechen Klartext und liefern messbare Ergebnisse.' },
            { icon: '🚀', title: 'Innovation', desc: 'Wir denken voraus, nicht nur mit.' },
            { icon: '🤝', title: 'Partnerschaft', desc: 'Projekte sind für uns keine Aufträge, sondern Allianzen.' }
          ].map((val, i) => (
            <div key={i} className="bg-white/5 border border-gray-700 rounded-xl p-6">
              <div className="text-3xl mb-3">{val.icon}</div>
              <h4 className="text-lg font-semibold text-fuchsia-300 mb-2">{val.title}</h4>
              <p className="text-gray-400 text-sm">{val.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <h3 className="text-2xl font-semibold mb-4 text-white">Bereit für den nächsten digitalen Schritt?</h3>
          <a
            href="/kontakt"
            className="inline-block bg-gradient-to-r from-fuchsia-600 to-pink-600 hover:brightness-110 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg"
          >
            Lass uns sprechen
          </a>
        </div>
      </div>
    </div>
  );
};

export default Ueber;